import {TypeLang} from '@/store/language/language'
import request from "./request"
import { getChatId } from '@/utils/chats'

type TPush = 'friend' | 'chat' | 'groupchat'
const WEB_DEVICE_TYPE = 3

interface PushApp {
  (id: string, type: Extract<TPush, 'chat' | 'groupchat'>, uid: string): Promise<any>
  (id: string, type: Exclude<TPush, 'chat' | 'groupchat'>): Promise<any>
}

export const pushApp: PushApp = (id: string, type: TPush, uid?: string) => {
  let formData = {}
  if (type === 'chat' || type === 'groupchat') {
    const fieldName = type === 'chat' ? 'memberId' : 'chatId'
    formData = {
      [fieldName]: getChatId(id),
      type: type,
      uid
    }
  } else if (type === 'friend') {
    formData = {
      memberId: id.split('@')[0],
      type: type,
    }
  }
  return request('get', '/api/push/notify', formData)
    .then(data => {
      return data.data
    })
}

export const pushCall = (memberId: string) => {
  return request('get', '/api/user/push-call', {
    called: memberId
  })
}

export interface ChangeTokenProps {
  token: string,
  lang: TypeLang
}
export const addToken = async(props: ChangeTokenProps): Promise<void> => {
  await request(
    'get',
    '/api/users/add-token',
    {
      ...props,
      deviceType: WEB_DEVICE_TYPE,
      device_name: window.navigator.userAgent,
      os_version: 'web'
    }
  )
}

export const changeLang = async(props: ChangeTokenProps): Promise<void> => {
  await request(
    'get',
    '/api/users/update/lang',
    props
  )
}

export const removeToken = async(token: string): Promise<void> => {
  await request(
    'get',
    '/api/users/remove-token', {
      deviceType: WEB_DEVICE_TYPE,
      token
    }
  )
}
